export const DRAFT_RESPONSE_PROMPT = "Draft response"
export const SUMMARIZE_PROMPT = "Summarize"
export const CHECK_SPELLING_PROMPT = "Check spelling"
export const DRAFT_FOLLOW_UP_PROMPT =
	"Draft a short follow up to the customer about this request."

const WRITING_PROMPTS = new Set([
	DRAFT_RESPONSE_PROMPT,
	SUMMARIZE_PROMPT,
	CHECK_SPELLING_PROMPT,
	DRAFT_FOLLOW_UP_PROMPT,
])

// A quick action that only writes text; the copilot gets no issue tools for it.
export function isWritingQuickAction(prompt: string): boolean {
	return WRITING_PROMPTS.has(prompt.trim())
}
